export type ListPaginationMeta = {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
};

export const initialListPaginationMeta: ListPaginationMeta = {
  totalItems: 0,
  itemCount: 0,
  itemsPerPage: 20,
  totalPages: 1,
  currentPage: 1,
};

export const getPaginationMeta = <T>(
  page: number,
  perPage: number,
  items: T[],
  meta?: Partial<ListPaginationMeta>
): ListPaginationMeta => {
  if (meta?.currentPage && meta?.totalPages) {
    return {
      totalItems: meta.totalItems ?? items.length,
      itemCount: meta.itemCount ?? items.length,
      itemsPerPage: meta.itemsPerPage ?? perPage,
      totalPages: meta.totalPages,
      currentPage: meta.currentPage,
    };
  }

  const hasMore = items.length >= perPage;

  return {
    totalItems: hasMore
      ? page * perPage + 1
      : (page - 1) * perPage + items.length,
    itemCount: items.length,
    itemsPerPage: perPage,
    totalPages: hasMore ? page + 1 : page,
    currentPage: page,
  };
};
